import withStyles from '@material-ui/core/styles/withStyles';
import TableCell, { TableCellProps } from '@material-ui/core/TableCell/TableCell';
import TableRow from '@material-ui/core/TableRow/TableRow';
import React from 'react';
import { generateString, log } from '../utils';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

const SHOW_LOG = false;

export interface TableProperties<T> {
  columns: {
    [key: string]: {
      title: string;
      props?: TableCellProps;
    };
  };
  transformData?: <T, U>(data: T[]) => U[];
  data?: T;
}

/**
 * generic generateTable helper function, this is just a simple helper to generate tables and prevent some dry, can have a lot of improvmente here, is just a starter
 * T is CurrentVersionPackages
 */
export const generateTable = function <T>({ columns, data }: TableProperties<T | undefined>): {
  tableHeadRows: JSX.Element[];
  tableDataRows: JSX.Element[];
} {
  const columnKeys: string[] = Object.keys(columns);
  const dataKeys: string[] = Object.keys(data as unknown as T);
  if (SHOW_LOG) {
    log(`columnKeys: [${JSON.stringify(columnKeys, undefined, 2)}]`);
    log(`dataKeys: [${JSON.stringify(dataKeys, undefined, 2)}]`);
  }
  // styles
  const StyledTableRow = withStyles(theme => ({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);
  // compose tableHeadRows
  const tableHeadRows: JSX.Element[] = columnKeys.map((columnKey: string) => {
    return (
      <TableCell key={generateString()} {...columns[columnKey].props}>
        {columns[columnKey].title}
      </TableCell>
    );
  });
  // init tableDataRows
  const tableDataRows: JSX.Element[] = [];
  dataKeys.forEach((dataKey: string) => {
    // log(data[dataKey]);
    // init current tableRow
    const tableRow: JSX.Element[] = [];
    columnKeys.forEach((columnKey: string) => {
      // log(`columnKey: ${columnKey}, value: ${(data as any)[dataKey][columnKey]}`);
      // use dataKey as cellValue
      const isBooleanValue = typeof (data as any)[dataKey][columnKey] === 'boolean';
      const cellValue = isBooleanValue ? (
        (data as any)[dataKey][columnKey] ? (
          <CheckIcon />
        ) : (
          <CloseIcon />
        )
      ) : (
        (data as any)[dataKey][columnKey]
      );
      tableRow.push(
        // weird we need a key in columns, else we have the infamous key error
        <TableCell {...columns[columnKey].props} key={generateString()}>
          {cellValue}
        </TableCell>
      );
    });
    // push row to tableDataRows
    tableDataRows.push(<StyledTableRow key={generateString()}>{tableRow}</StyledTableRow>);
  });
  return { tableHeadRows, tableDataRows };
};
